export default __webpack_public_path__ + "static/media/badge-check.9fc20864.svg";